<div class="cont-button-p-d"
  (click)="addRemoveFavorite()"
  [class.border-btn]="border"
  [class.cont-button-p-d--mini]="isMini">
  <img class="img" [class.animate-heart]="activeAnimation" [src]="'assets/svg/' + (productFavorite ? 'heart-blue' : 'heart') + '.svg'" alt="Producto Favoritos">
</div>
